Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SocialContentDetailsContentIDView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/details/content_id']

  initialize: ({@id}) ->
    undefined

  render: ->
    @setElement @template
      id: @id
    @
